import React, { useRef } from 'react';
import { Calendar } from 'primereact/calendar';

function DateSelection({ value, onChange }) {
  const calendarRef = useRef(null);

  const handleDateSelect = (e) => {
    onChange(e.value);

    if (e.value !== null && calendarRef.current) {
      calendarRef.current.hide();
    }
  };

  return (
    <Calendar
      className='date-selection'
      value={value}
      onChange={handleDateSelect}
      readOnlyInput
      ref={calendarRef}
      dateFormat="dd MM yy"
    />
  );
}

export default DateSelection;
